export default "__VITE_ASSET__D47fd5BO__"